import client from '../utils/client';
import { slidersUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const sliderService = {
  slidersList,
  addSlider,
  getSlider,
  updateSlider
}

function slidersList(pageID, perPage) {
  return client.get(slidersUrl + '?page=' + pageID + '&per_page=' + perPage)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function addSlider(formDate) {
  return client.post(slidersUrl + '/images/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getSlider(sliderID) {
  return client.get(slidersUrl + '/1/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updateSlider(formDate) {
  return client.post(slidersUrl + '/images/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}


function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}